import React from "react";

export function ErrorSVG() {
  return (
    <svg
      fill="none"
      height="15"
      viewBox="0 0 15 15"
      width="15"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="7.49999" cy="7.50005" r="5.85723" />
      <path d="M7.5 4.5V8.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.5 10.51V10.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
